const swiper = new Swiper('#slider-show', {
  direction: 'horizontal',
  spaceBetween: 24,
  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
  pagination: {
    el: '.pagination',
    type: 'bullets',
    bulletClass: 'pagination-item',
    bulletActiveClass: 'active',
    clickable: true,
    renderBullet: function (index, className) {
      const slides = document.querySelectorAll('.swiper-slide');
      const slide = slides[index];
      const title = slide.dataset.swiperTitle;
      const subtitle = slide.dataset.swiperSubtitle;
      const link = slide.dataset.swiperLink;

      return `
        <div class="slider-show__pagination ${className}" data-swiper-link="${link}">
          <div class="visual-effet"></div>
          <p class="title">${title}</p>
          <p class="subtitle">${subtitle}</p>
        </div>
      `;
    },
  },
});

document.querySelectorAll('.swiper-slide').forEach((slide) => {
  slide.addEventListener('click', (event) => {
    event.preventDefault();
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
    const link = slide.dataset.swiperLink;
    if (!link) return;
    if (document.querySelector('.header-menu.open')) {
      return;
    }

    if (link.match(/^https?:\/\//)) {
      window.open(link, '_blank', 'noopener noreferrer');
    } else {
      window.location.href = link;
    }
  });
});
